import React, { useState } from "react";
import "./HomeOffer.scss";

import { Link } from "react-router-dom";
import { ReactComponent as SideBtnBlack } from "../../assets/svg/side-btn-black.svg";
import { ReactComponent as OfferSvg1 } from "../../assets/svg/offer-svg-1.svg";
import { ReactComponent as OfferSvg2 } from "../../assets/svg/offer-svg-2.svg";
import { ReactComponent as OfferSvg3 } from "../../assets/svg/offer-svg-3.svg";
import { ReactComponent as ArrUpp } from "../../assets/svg/ArrUp.svg";
import { ReactComponent as ArrDown } from "../../assets/svg/Arr-down.svg";

import { SkillData } from "../../data/data";

const HomeOffer = () => {
  const [showAnswers, setShowAnswers] = useState(
    Array(SkillData.length).fill(false)
  );

  const toggleAnswer = (index) => {
    setShowAnswers((prevShowAnswers) => {
      const newShowAnswers = prevShowAnswers.map((value, idx) => {
        return idx === index ? !value : false;
      });
      return newShowAnswers;
    });
  };

  return (
    <>
      <section className=" section homeOffer__banner">
        <article className="homeOffer__banner--container container">
          <div className="homeOffer__banner--container-left">
            <h2 className="homeOffer__title">Our</h2>
            <h3 className="homeOffer__subtitle">Services</h3>
          </div>

          <div className="homeOffer__banner--container-right">
            <p>
              At Radiksez, your vision is our compass. Through our proven
              process, we navigate challenges, crafting stellar results that
              reflect our commitment to excellence!
            </p>

            <Link to="/contact-us" className="process-contact__btn">
              <button className="contact__btn">
                <span> Contact Us</span>
              </button>
              <SideBtnBlack />
            </Link>
          </div>
        </article>
      </section>

      <section className="homeOffer">
        <article className="homeOffer__container container">
          <div className="homeOffer__container--contents">
            <div className="homeOffer__container--contents-left">
              <div className="contents-left-item">
                <OfferSvg1 className="offer-svg-1" />
                <li>Design</li>
              </div>
              <div className="contents-left-item">
                <OfferSvg2 className="offer-svg-2" />
                <li>Marketing</li>
              </div>
              <div className="contents-left-item">
                <OfferSvg3 className="offer-svg-3" />
                <li>Development</li>
              </div>
            </div>

            <div className="homeOffer__container--contents-right">
              {SkillData.map((skills, index) => {
                const { id, title, answer } = skills;
                const isOpen = showAnswers[index];
                return (
                  <div className="contents-right-item" key={id}>
                    <div
                      className="contents-right-item-header"
                      onClick={() => toggleAnswer(index)}
                    >
                      <h3 className="open-service">{title}</h3>
                      <button
                        type="button"
                        className={
                          isOpen
                            ? "open-service-btn active-open-btn"
                            : "open-service-btn"
                        }
                      >
                        {isOpen ? <ArrUpp /> : <ArrDown />}
                      </button>
                    </div>

                    {/* Show the answer only if showAnswers[index] is true */}
                    {isOpen && (
                      <p className="contents-right-item-text">{answer}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </article>
      </section>
    </>
  );
};

export default HomeOffer;
